import { render, staticRenderFns } from "./WorkspaceTest.vue?vue&type=template&id=bb72df28&scoped=true"
import script from "./WorkspaceTest.vue?vue&type=script&lang=js"
export * from "./WorkspaceTest.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceTest.vue?vue&type=style&index=0&id=bb72df28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb72df28",
  null
  
)

export default component.exports